module.exports = __webpack_public_path__ + "static/kantor-b537ab4760afb54c2810c2ea735300f6.jpg";